<template>
  <div id="mainmenu" class="align-right">
    <div id="menu-content">
      <ul class="unstyled">
        <li v-for="link in links" @click="handleNavigation">
          <router-link 
            :to="{ name: link.to }" 
            exact 
            class="main-nav-item"
            :class="linkClasses(link)"
          >{{ link.name }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
export default {
  name: 'navigation',
  data () {
    return {
      title: '',
      links: DataStore.links,
      delay: 380
    }
  },
  methods: {
    linkClasses (link) {
      return this.$route.name === link.to ? 'active' : ''
    },
    handleNavigation () {
      this.$emit('navigating')
      this.scrollTop()
    },
    scrollTop () {
      this.$scrollTo('html, body')
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss
  @import ../assets/styles/scss/mixins.scss

  #mainmenu
    position: fixed
    width: 100%
    height: 100%
    margin-top: 10%

    > #menu-content
      top: 0
      left: 0

      > ul.unstyled
        position: relative
        top: -11px
        margin-top: 0
        margin-bottom: 0

        @media screen and (min-width: $break-large)
          top: -5px

        > li
          vertical-align: top
          font-size: 1.4em
          padding-right: 20px

          @media screen and (min-width: $break-small)
            font-size: 1.7em

          @media screen and (min-width: $break-medium)
            font-size: 1.8em

          @media screen and (min-width: $break-large)
            font-size: 2.2em
            margin-bottom: 10px

          > a.main-nav-item
            text-transform: uppercase
</style>



// WEBPACK FOOTER //
// NavigationMenu.vue?9567e086